import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { isAgent, isAdmin, isStaff, isSuperAdmin, isStudent } from '../../utils/roleUtils'
import { Clock, ShieldAlert, LogOut } from 'lucide-react'
import PageHeader from '../../components/common/PageHeader'
import './styles.scss'

export default function PendingApproval() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const getRoleName = () => {
    if (isSuperAdmin(user)) return 'Super Administrator'
    if (isAdmin(user)) return 'Administrator'
    if (isStaff(user)) return 'Admissions Staff'
    if (isAgent(user)) return 'Recruitment Agent'
    if (isStudent(user)) return 'Student'
    return 'User'
  }

  const getMessage = () => {
    if (isAgent(user)) {
      return 'Please wait for an Administrator to verify your agency details and grant you Agent privileges.'
    }
    if (isStaff(user) || isAdmin(user)) {
      return 'Please wait for a Super Admin to assign you to a University Team and grant you administrative privileges.'
    }
    return 'Your account is pending verification. Please wait for an administrator to validate your role.'
  }

  return (
    <div className="pending-approval-page">
      <PageHeader 
        title="Role Validation Pending" 
        subtitle="Your account is waiting for administrative access." 
      />

      <div className="pending-content glass-panel">
        <div className="status-icon">
          <Clock size={48} color="#F59E0B" />
        </div>
        
        <h2>Welcome, {user?.fullName || 'User'}!</h2>
        
        <p className="status-message">
          You have registered as a <strong>{getRoleName()}</strong>. Your account has been successfully created, but you currently do not have the necessary permissions to access the platform.
        </p>
        
        <div className="info-box">
          <ShieldAlert size={20} color="#3B82F6" />
          <span>{getMessage()}</span>
        </div>

        <p className="refresh-note">
          Once your role has been validated, you will receive an email. Please log out and log back in to access your dashboard.
        </p>

        <div className="action-buttons">
          <button className="btn btn-outline" onClick={() => window.location.reload()}>
            Refresh Page
          </button>
          <button className="btn btn-primary" onClick={logout}>
            <LogOut size={16} /> Log Out
          </button>
        </div>
      </div>
    </div>
  )
}
